import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "_common/ui/forms/Input";
import styles from "main/footer/_css/footerSubscribe.module.css";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { notifierStore } from "components/misc/contactUs/_stores/notifierStore";
import { useLoadingFromPromise } from "_common/loaders/useLoadingFromPromise";
import { observer } from "mobx-react";
import { ButtonNotification } from "components/misc/notifications/ButtonNotificationProps";
import { CheckboxAgreeFooter } from "main/footer/CheckBoxAgreeFooter";
import { ArrowForward } from "@material-ui/icons";

export type TContactFooterForm = {
    firstName: string;
    lastname?: string;
    email: string;
};

export const FooterSubscribe = observer(() => {
    const { t } = useTranslation();
    const [hasAgreedNotification, setHasAgreedNotification] = useState(false);
    const form = useForm<{ email: string }>();
    const { loading, setPromise } = useLoadingFromPromise();
    const isLoading = loading?.status === "LOADING";

    return (
        <div className={styles.container}>
            <div className={styles.title}>{t("footer.subscribeTitle")}</div>
            <div className={styles.text}>{t("footer.subscribeText")}</div>
            <FormProvider {...form}>
                <div className={styles.inputRow}>
                    <Controller
                        className={styles.input}
                        as={Input}
                        name={"email"}
                        control={form.control}
                        defaultValue={""}
                        placeholder={t("footer.mailPlaceholder")}
                        aria-label={t("footer.mailLabel")}
                    />
                    <ButtonNotification
                        variant={"contained"}
                        color={"primary"}
                        className={styles.btn}
                        onClick={form.handleSubmit<{ email: string }>((data) => {
                            if (!isLoading) {
                                setPromise(notifierStore.contactFromFooter({ firstName: "", email: data.email }));
                            }
                        })}
                    >
                        {isLoading ? (
                            t("loaders.message")
                        ) : (
                            <span className={styles.btnLabel}>
                                {t("footer.subscribe")}
                                <ArrowForward className={styles.btnArrow} />
                            </span>
                        )}
                    </ButtonNotification>
                </div>
                <CheckboxAgreeFooter checked={hasAgreedNotification} onChange={setHasAgreedNotification} />
            </FormProvider>
        </div>
    );
});
